// Third Party Imports
import React from 'react';
import {AlertInfo} from '@homeaway/react-alerts';
import {CLOSE__16} from '@homeaway/svg-defs/lib/defs/CLOSE__16';
import {SVGIcon} from '@homeaway/react-svg';

// Relative imports
import './AlertBox.less';

class AlertInfoBox extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        let {
            closeInfoIcon,
            alertBoxContent,
            alertBoxHeader
        } = this.props;

        return (
            <div className="alert-box-info">
                <AlertInfo className="alert-info">
                    <div className="alert-info-wrapper">
                        <div className="close-btn-holder">
                            <button className="close-btn" onClick={closeInfoIcon}>
                                <SVGIcon markup={CLOSE__16} />
                            </button>
                        </div>
                        <div>{alertBoxHeader}</div>
                        {alertBoxContent}
                    </div>
                </AlertInfo>
            </div>
        );
    }
}

export default AlertInfoBox;
